export default {
    paybooking(data) {
        return axios.post('/api/booking/paybooking', data);
    },
    mybookings() {
        return axios.get("/api/booking/mybookings");
    },
};
